import type { PushNotificationClickAction } from "src/notifications/pushNotificationClickAction.ts";
import React from "react";

export const PushNotificationsContext = React.createContext<
	PushNotificationsContextValue | undefined
>(undefined);

export interface PushNotificationsContextValue {
	registrationToken: string | null;
	clickAction: PushNotificationClickAction | null;
	onClickActionHandled: (actionId: string) => void;
	deleteRegistration: () => Promise<void>;
}
